import { Controller } from '@hotwired/stimulus';


export default class extends Controller {
    static targets = ['button', 'dropdown', 'name', 'dot'];
    static classes = ['open'];

    connect() {
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        document.addEventListener('click', this.handleOutsideClick);
    }

    disconnect() {
        document.removeEventListener('click', this.handleOutsideClick);
    }

    toggle(event) {
        event.stopPropagation();
        this.element.classList.toggle(this.openClass);
    }

    close() {
        this.element.classList.remove(this.openClass);
    }

    handleOutsideClick(event) {
        if (!this.element.contains(event.target)) {
            this.close();
        }
    }

    select(event) {
        const index = Number(event.params.index);
        const button = event.currentTarget;
        const id = button.dataset.contractId;

        this.element.querySelectorAll('.contract-switcher__item').forEach((el, i) => {
            el.classList.toggle('contract-switcher__item--selected', i === index);
        });

        this.close();

        this.dispatch('select', {
            detail: { index, id },
            bubbles: true,
        });
    }

    updateButton({ name, id, status }) {
        if (this.hasNameTarget) {
            this.nameTarget.textContent = `${name} (${id})`;
        }
        if (this.hasDotTarget) {
            this.dotTarget.className = `contract-switcher__dot contract-switcher__dot--${status}`;
        }
    }
}
